import { useLayoutEffect, useCallback } from 'react';

import { useOnKeyDown } from '../../feature-player/hooks/skin/use-on-key-down';
import { KEYBOARD_KEY_CODES, KeyboardKeys } from '../../feature-player/constants/keyboard';

interface Params {
    onClose: () => void;
}

export const useKeyboard = ({ onClose }: Params) => {
    const onKeyDownBase = useOnKeyDown({ onClose, isChannel: true });

    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            const { ArrowLeft, ArrowRight, KeyJ, KeyL } = KeyboardKeys;

            if (KEYBOARD_KEY_CODES.some((code) => code === event.code)) {
                event.preventDefault();
            }

            switch (event.code) {
                case ArrowRight:
                case KeyL:
                case ArrowLeft:
                case KeyJ: {
                    break;
                }
                default: {
                    onKeyDownBase(event);
                }
            }
        },
        [onKeyDownBase]
    );

    useLayoutEffect(() => {
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onKeyDown]);
};
